<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

      v-card(flat)
        v-card-title.pa-0
          v-row.px-5.pt-3.pb-2(v-if="hasChanges" no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].success600}`")
            v-col.shrink
              v-btn.ml-n3(text icon @click="closeDialog()" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic100--text {{ $t('save_changes') }}
            v-col.ml-3.shrink
              v-layout
                v-btn.mr-2.my-auto(depressed small outlined color="basic100" @click="clickRevert()")
                  .button-AA-small.basic100--text {{ $t('cancel') }}
                v-btn.my-auto.basic100(depressed small @click="clickSave()" :loading="isLoading")
                  .button-AA-small.primary500--text {{ $t('save') }}
          
          v-row.px-5.pt-3.pb-2(v-else no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="closeDialog()" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.primary500--text {{ $t('store_pickup') }}

        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

        v-card-text.pa-0.pb-12(v-else-if="courier")
   
          v-form.mt-4(ref="form")

            v-card.py-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .header.px-4
                .s1 {{ $t('address_for_store_pickup') }}
              
              v-divider.basic300.my-4
              
              .pickup-address.px-4
                v-row.pa-0.clickable(@click="showUpdateCourierAddress = true")
                  v-col.py-0
                    .label.basic600--text.text-uppercase.my-auto {{ $t('store_address') }}
                    .p2.basic700--text {{ courier.pickup_address.address_1 }}, {{ courier.pickup_address.address_2 }}, {{ courier.pickup_address.postcode }}, {{ courier.pickup_address.city }}, {{ courier.pickup_address.state }}, {{ courier.pickup_address.country }}
                    .p2.basic700--text(v-if="courier.pickup_address.phone") {{ courier.pickup_address.phone | phoneFormat }}
                  v-col.py-0.shrink
                    eva-icon(name="arrow-ios-forward-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="20" height="20")
            
            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .s1 {{ $t('pickup_instructions') }}
              div.d-flex
                v-spacer
                .c1.basic600--text.mr-1(v-if="courier.instruction") {{ courier.instruction.length }}/300
              v-textarea.mt-2(v-model='courier.instruction' :placeholder="$t('pickup_instructions_placeholder')" outlined dense persistent-hint background-color="basic200" :rules="rules.instructions_count" hide-details="auto")

            v-card.pa-4.mx-4.mt-4(flat style="border:1px solid var(--v-basic300);")
              .s1 {{ $t('pay_at_shop') }}
              .c1.basic600--text {{ $t('pay_at_shop_text') }}
              v-row(align='center')
                v-col
                  .p2.basic700--text {{ $t('enable_pay_at_shop') }}
                v-col.shrink
                  y-switch(:color="$vuetify.theme.themes[$theme].success400" v-model="enablePayAtShop")

    .modals
      store-pickup-address(v-if="showUpdateCourierAddress" :open.sync="showUpdateCourierAddress" :company.sync="company" @finished="fetchShippingCourier()" :isEditing="true" :courier.sync="courier")
            
</template>

<script>
import { mapActions } from 'vuex'
import StorePickupAddress from '@/components/dialogs/settings/yezzashipping/StorePickupAddress.vue'

export default {
  name: 'StorePickupSettings',
  components: { StorePickupAddress },
  props: ['open', 'company'],
  data: () => ({
    isFetching: false,
    originalCourier: null,
    courier: null,
    selectedShipping: null,
    showUpdateCourierMethod: false,
    showUpdateCourierAddress: false,
    isLoading: false,
    courierList: [
      { name: 'Lalamove', id: 'Lalamove' },
      { name: 'Borzo', id: 'Borzo' },
      { name: 'Grab', id: 'Grab' }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required'],
      instructions_count: [(v) => !!v || 'This field is required', v => (v || '').length <= 300 || 'Max 300 characters']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    hasChanges () {
      if (JSON.stringify(this.courier) !== JSON.stringify(this.originalCourier)) {
        return true
      }
      return false
    },
    enablePayAtShop: {
      get() {
        if (this.courier) {
          return this.courier.pay_at_shop
        }
        return false
      },
      set(newValue) {
        this.courier.pay_at_shop  = newValue
      }
    }
  },
  mounted () {
    this.fetchShippingCourier()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchShippingCourier() {
      this.isFetching = true
      this.$axios.get(`/shipping/settings/${this.company.slug}/storepickup`)
        .then((response) => {
          this.courier = { ...response.data }
          this.originalCourier = { ...response.data }
          this.isFetching = false
        }).catch(() => {})
    },
    clickRevert () {
      this.courier = { ...this.originalCourier }
    },
    closeDialog () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.showModal = !this.showModal
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      this.axios.patch(`/shipping/settings/${this.company.slug}/storepickup/`, this.courier)
        .then(() => {
          this.originalCourier = { ...this.courier }
          this.$emit('updated')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "address_for_store_pickup": "Address for store pickup",
    "store_address": "Store address",
    "pickup_instructions": "Pickup instructions",
    "pickup_instructions_placeholder": "e.g. Where to go in the store, what information you will need etc",
    "pay_at_shop": "Pay at shop",
    "pay_at_shop_text": "Customers can choose to skip payment during order submission.",
    "enable_pay_at_shop": "Enable pay at shop"
  },
  "id": {
    "address_for_store_pickup": "Alamat pengambilan",
    "store_address": "ALAMAT TOKO",
    "pickup_instructions": "Instruksi Pengambilan",
    "pickup_instructions_placeholder": "misalnya Ke mana harus pergi ke toko, informasi apa yang kamu perlukan, dll",
    "pay_at_shop": "Bayar di toko",
    "pay_at_shop_text": "Pelanggan dapat memilih untuk melewatkan pembayaran selama pengiriman pesanan.",
    "enable_pay_at_shop": "Aktifkan pembayaran di toko"
  }
}
</i18n>
